/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Button from 'components/button';
import { successNotice, errorNotice } from 'state/notices/actions';
import cecSdk from 'lib/customer-ec-sdk';
import JumpingDots from 'components/jumping-dots';

const TestApiConnectionButton = ({ connectionId, details, ...props }) => {
   
    const [testing, setTesting] = useState(false);

    const testConnection = async () => {
        setTesting(true);
        try {
            let { result } = await cecSdk.connection(connectionId).test({ connectionDetails: details });

            if (result) {
                props.successNotice('Valid connection');
            } else {
                props.errorNotice('Invalid connection');
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');
            console.log(error);
        }
        setTesting(false);
    };

    return (
        <Button disabled={testing} onClick={testConnection}>
            {testing ? <div>Testing connection details <JumpingDots /></div> : 'Test connection details'}
        </Button>
    );

};

export default connect(null, {
    successNotice,
    errorNotice,
})(TestApiConnectionButton);
